import { ReactNode, useEffect, useState } from 'react';
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import styles from './Modal.module.css';
import { LFC } from '../../types';
import { CloseButton } from './CloseButton';

export interface ModalProps {
  open?: boolean;
  title?: string | ReactNode;
  className?: string;
  onClose?: () => void;
}

export const Modal: LFC<ModalProps> = ({
  open,
  title,
  onClose,
  className,
  children,
}) => {
  const [openAnimation, setOpenAnimation] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setOpenAnimation(!!open);
    }, 20);

    return () => {
      clearTimeout(timeout);
    };
  }, [open]);

  return createPortal(
    <div
      className={clsx(
        styles.modal,
        { [styles.open]: openAnimation },
        className
      )}
    >
      <div className={styles.titleLine}>
        <span data-testid="modal-title">{title}</span>
        <div>
          <CloseButton onClick={onClose} />
        </div>
      </div>
      <div className={styles.content}>{children}</div>
    </div>,
    document.getElementById('root')!
  );
};
